/** 控制台 — 电表列表页（与 electricity.vue 文案一致） */
export default {
  deviceElectricity: {
    searchPlaceholder: '输入电表名称/序列号',
    bindInfoPlaceholder: '绑定信息',
    meterTypePlaceholder: '电表类型',
    switchStatusPlaceholder: '分合闸状态',
    onlineStatusPlaceholder: '在线状态',
    expand: '展开',
    collapse: '收起',
    search: '查询',
    reset: '重置',
    export: '导出',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    sectionList: '电表列表',
    sectionCard: '电表卡片',
    add: '新增',
    sortDefault: '默认排序',
    viewList: '列表',
    viewCard: '卡片',
    selectedCount: '已选择 {count} 条数据',
    bindTypeDedicated: '专用表',
    bindTypePublic: '公摊表',
    bindTypeFormula: '公式表',
    bindTypeAc: '空调表',
    bindTagDedicated: '专用',
    bindTagPublic: '公摊',
    bindTagFormula: '公式',
    bindTagAc: '空调',
    switchOff: '分闸',
    switchOn: '合闸',
    online: '在线',
    offline: '离线',
    prepaid: '预付费',
    prepaidStrong: '强控',
    phaseThreePrimary: '三相一次',
    phaseThreeSecondary: '三相二次',
    phaseSinglePrimary: '单相一次',
    unbound: '未绑定',
    colSerial: '序列号',
    colMeterName: '电表名称',
    colType: '类型',
    colBindInfo: '已绑信息',
    colPayMode: '付费模式',
    colPricePlan: '电费方案',
    colPhase: '电表规格',
    colSwitch: '分合闸状态',
    colOnline: '在线状态',
    colOfflineComment: '备注',
    colSyncTime: '最新数据时间',
    colCreateTime: '创建时间',
    cardSerial: '序列号',
    cardBindInfo: '已绑信息',
    cardPricePlan: '电费方案',
    cardLatestReading: '最新数据',
    opOpen: '分闸',
    opClose: '合闸',
    opEdit: '编辑',
    opDetail: '详情',
    opColumn: '操作',
    copySerialTip: '点击可复制',
    priceSharp: '尖电价',
    pricePeak: '峰电价',
    priceFlat: '平电价',
    priceValley: '谷电价',
    emptyNoData: '暂无数据',
    dialogEditTitle: '编辑电表',
    dialogAddTitle: '新增电表',
    labelSerial: '序列号',
    labelImei: 'IMEI',
    labelMeterName: '电表名称',
    labelMeterType: '电表类型',
    labelPayMode: '付费模式',
    labelPhase: '电表相位',
    labelCt: 'CT',
    labelPt: 'PT',
    labelPricePlan: '电价方案',
    placeholderSerial: '请输入序列号',
    placeholderImei: '请输入IMEI',
    placeholderMeterName: '请输入电表名称',
    placeholderSelectMeterType: '请选择电表类型',
    placeholderSelectPayMode: '请选择付费模式',
    placeholderSelectPhase: '请选择电表相位',
    placeholderCt: '请输入CT值',
    placeholderPt: '请输入PT值',
    placeholderSelectPrice: '请选择电价方案',
    priceLineMeta: '峰:{peak}元 平:{flat}元 谷:{valley}元',
    btnCancel: '取 消',
    btnConfirm: '确 定',
    saving: '保存中...',
    payTypeDialogTitle: '操作确认',
    payTypeDialogBody: '该电表为预付费模式，需要先修改为强控模式才能进行分合闸操作。',
    payTypeDialogAsk: '是否立即修改？',
    switchVerifyMeter: '电表',
    switchVerifyAction: '操作',
    switchVerifyPhone: '绑定手机',
    switchVerifyCode: '验证码',
    placeholderVerifyCode: '请输入验证码',
    sendSmsCode: '发送验证码',
    ruleSerial: '请输入序列号',
    ruleMeterName: '请输入电表名称',
    ruleBindType: '请选择电表类型',
    rulePayMode: '请选择付费模式',
    rulePhase: '请选择电表相位',
    switchVerifyTitleBase: '分合闸操作',
    switchVerifyTitleFmt: '{action}操作验证',
    actionOpen: '分闸',
    actionClose: '合闸',
    errPriceList: '获取价格方案失败',
    errTenantList: '获取租户列表失败',
    errFetchList: '获取数据失败',
    errFetchMeters: '获取电表数据失败',
    successSaveUpdate: '修改成功',
    successSaveAdd: '新增成功',
    errOperation: '操作失败',
    infoSearchingSerial: '正在查询序列号为 {serial} 的电表...',
    warnNoPhone: '未获取到绑定手机号',
    successCodeSent: '验证码已发送',
    errSendCode: '发送验证码失败',
    warnEnterCode: '请输入验证码',
    confirmSwitchTitle: '提示',
    confirmSwitchMsg: '确定要对电表「{name}」执行{action}操作吗？',
    btnOk: '确定',
    btnCancelShort: '取消',
    successSwitch: '{action}操作成功',
    errSwitch: '{action}操作失败',
    successPayTypeUpdate: '付费模式修改成功',
    errUpdate: '修改失败',
    errPayTypeUpdate: '修改付费模式失败',
    warnNothingToCopy: '无可复制内容',
    successSerialCopied: '序列号已复制',
    errCopy: '复制失败',
    warnTenantNotBound: '该电表未绑定租户',
    warnNoExportData: '暂无数据可导出',
    warnNoSelectedExport: '请先勾选要导出的数据',
    successExported: '成功导出 {count} 条数据',
    successExportedLimit: '共 {total} 条，已导出前 {count} 条',
    errExport: '导出失败',
    exporting: '正在导出...',
    exportSheetName: '电表数据',
    exportFilePrefix: '电表数据',

    meterDrawerTitle: '详情',
    meterDrawerColId: '编号',
    meterDrawerColInstallLoc: '安装位置',
    meterDrawerBindCardTitle: '已绑信息',
    meterDrawerNoBind: '暂无绑定信息',
    meterDrawerNoPricePlan: '暂无电价方案',
    meterDrawerPricePlanLabel: '电费方案',
    meterDrawerMetricRealtimeP: '实时功率/kW',
    meterDrawerMetricPf: '实时功率因数',
    meterDrawerMetricMonthPeak: '月功率峰值/kW',
    meterDrawerMetricYesterdayKwh: '昨日电量/度',
    meterDrawerSectionPowerCurve: '功率曲线',
    meterDrawerDatePlaceholder: '选择日期',
    meterDrawerViewTable: '表格',
    meterDrawerViewLineChart: '折线图',
    meterDrawerColCollectTime: '采集时间',
    meterDrawerEmptyPower: '暂无功率数据',
    meterDrawerSectionUsage: '近期用电统计',
    meterDrawerLinkFullReport: '查看详细报表',
    meterDrawerColDate: '日期',
    meterDrawerColTotalFee: '总电费(元)',
    meterDrawerColTotalKwh: '总电量(度)',
    meterDrawerColTierSharp: '尖(度)',
    meterDrawerColTierPeak: '峰(度)',
    meterDrawerColTierFlat: '平(度)',
    meterDrawerColTierValley: '谷(度)',
    meterDrawerGroupStartReading: '起始读数',
    meterDrawerGroupEndReading: '截止读数',
    meterDrawerColSubTime: '时间',
    meterDrawerColSubTotal: '总电量',
    meterDrawerColSubSharp: '尖',
    meterDrawerColSubPeak: '峰',
    meterDrawerColSubFlat: '平',
    meterDrawerColSubValley: '谷',
    meterDrawerEmptyUsage: '暂无用电统计数据',
    meterDrawerChartMax: '最大值',
    meterDrawerChartMin: '最小值',
    meterDrawerWarnPrepaidNoSwitch: '预付费模式下不能直接操作分合闸',
    batchSetOfflineType: '批量设置离线类型',
    batchOfflineTypeDialogTitle: '批量设置离线类型',
    batchOfflineTypeLabel: '离线类型',
    batchOfflineTypeComment: '备注',
    phOfflineComment: '请输入备注',
    offlineTypeOnline: '在线',
    offlineTypeAbnormal: '异常离线',
    offlineTypeNormal: '正常离线',
    batchOfflineTypeSelectedTip: '已选择 {count} 台电表',
    warnNoMeterSelected: '请先勾选需要操作的电表',
    warnOnlineMeterSelected: '选中的电表中有 {count} 台在线电表，仅离线电表可设置离线类型',
    warnSelectOfflineType: '请选择离线类型',
    successBatchOfflineType: '批量设置离线类型成功',
    errBatchOfflineType: '批量设置离线类型失败'
  }
}
